import { Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';
import { SeriesService } from 'src/app/Core/services/series.service';
import { UtilService } from 'src/app/Core/services/util.service';
import * as _ from 'lodash';
import * as moment from 'moment';
import { Constant } from 'src/app/Core/services/data';
import { TranslateService } from '@ngx-translate/core';
import { PlaylistService } from 'src/app/Core/services/playlist.service';
declare var $: any;

@Component({
  selector: 'app-series-detail',
  templateUrl: './series-detail.component.html',
  styleUrls: ['./series-detail.component.css']
})
export class SeriesDetailComponent implements OnInit {
  @ViewChild('scrollContainer', { static: false }) scrollContainer!: ElementRef;
  @ViewChildren('seriesItem') seriesItems!: QueryList<ElementRef>;
  isScrollable: boolean = false;

  public isLoading: boolean = false;
  isFavourit: boolean = false;
  favSeries: any;
  id: any;
  seriesinfo: any;
  episodeLen: any;
  seasonLen: any;
  seasonId: any = 1;
  episodes: any;
  allepisodes: any = [];

  isAtStart = true;
  isAtEnd = false;
  JSONDatas = [
  ];
  slideConfig = {
    "slidesToShow": 6, "slidesToScroll": 6, responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 6
        }
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  };
  slideConfigs = {
    "slidesToShow": 4, "slidesToScroll": 4, responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4
        }
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  };
  seriesFrom: any;
  categoryId: any
  seriesData:any
  loadSeries:boolean=false;
  OToken:any;
  isLocal:boolean= true;
  profile_id:any;
  stream_Url: any;
  constructor(private location: Location,private playlistService:PlaylistService, private router: Router, private seriesService: SeriesService, private utilService: UtilService,
    private route: ActivatedRoute, private toastr: ToastrService,private translate:TranslateService) {
    this.route.queryParams.subscribe((params: any) => {
      this.seriesFrom = params.seriesBy;
      this.categoryId = params.categoryId;
    })
    this.OToken = this.utilService.getOneStreamToken();

  }

  ngOnInit(): void {
    if(this.OToken){
      this.id = String(this.route.snapshot.params['id']);
    }else{
      this.id = this.route.snapshot.params['id']
    }
    this.getSeriesInfo(this.id);
    const profileData = JSON.parse(localStorage.getItem('Profile') || '{}');
    const mtoken = localStorage.getItem('mtoken') || '{}';
    this.profile_id = profileData.profile_id;
    if(mtoken === '{}'){
      this.isLocal = true;
    }else{
      this.checkFav(this.profile_id);
      this.isLocal = false;
    }
    if (this.id) {
      let isExist: any;
      this.favSeries = JSON.parse(localStorage.getItem(Constant.SERIES_FAV)) || [];
      const seriesId = typeof this.id === 'number' ? this.id : String(this.id);
      console.log(seriesId,'seriesIDS');
      
      if (this.favSeries.length > 0) {
        isExist = _.findIndex(this.favSeries, { id: seriesId});
        console.log(isExist,'exists');
        
        if (isExist >= 0) {
          this.isFavourit = true;
        }
      }else{
        console.log(this.id,'eles');
        
      }
    }
  
  }

  checkFav(id:any){
    this.playlistService.getAllFavData(id).subscribe((res:any)=>{
      console.log(res,this.id);
      const fabData = res;
      const favMovieData = fabData.filter(item => item.content_id == this.id );
      console.log(favMovieData,'fav movies data');
      if(favMovieData[0].content_id == this.id){
        this.isFavourit = true;
      }else{
       this.isFavourit = false;
      }
    })
  }


  ngAfterViewInit(): void {
      setTimeout(() => {
    // this.checkScrollPosition(); 
    // this.checkScrollability();
    this.onResize();
    window.addEventListener('resize', this.onResize);
    this.scrollContainer.nativeElement.addEventListener('wheel', this.handleWheelScroll, { passive: false });

  }, 2000);
    setTimeout(() => {
      $(".center").slick({
        accessibility: true,
        arrows: true,
        dots: true,
        infinite: true,
        centerMode: true,
        slidesToShow: 5,
        slidesToScroll: 3
      });
    }, 2000);

  }
  handleWheelScroll = (event: WheelEvent) => {
  // Only apply when there's vertical scrolling (default mouse scroll)
  if (Math.abs(event.deltaY) > 0) {
    event.preventDefault(); // Prevent vertical scroll
    this.scrollContainer.nativeElement.scrollLeft += event.deltaY;
    this.checkScrollPosition();
  }
};

  getSeriesInfo(id: any) {
    this.utilService.showSpinner()
    this.isLoading = true;
    this.seriesService.getSeriesDetail(id).subscribe((res: any) => {
      this.utilService.hideSpinner()
      this.isLoading = false;
      this.seriesinfo = res;
      
      this.seriesinfo.selectedEpisodes = this.seriesinfo.episodes[this.seasonId];
      this.seriesData = JSON.stringify(this.seriesinfo.selectedEpisodes)
      localStorage.setItem('seriesData',this.seriesData)
      this.episodeLen = 0;
      this.episodes = res.episodes;
      console.log(this.episodes,'epigosfjlasdkfjlasdkfj');
      
      if (this.episodes) {
        Object.keys(res.episodes).forEach(key => {
          this.episodeLen = this.episodeLen + res.episodes[key].length;
        });
      }
      this.seasonLen = res.seasons.length;
      // getting series Id to default call 
      for(let i=0;i<this.seriesinfo.seasons.length;i++){
        console.log(i,'iterate',this.seriesinfo.seasons[i].season_number);
        
        if(i === 0){
          this.isLoading =true;
          setTimeout(() => {
            this.onSelectSeason(this.seriesinfo.seasons[i].season_number)
          }, 1000);
          break;
        }
      }
    }, err => {
      this.isLoading = false;
      this.loadSeries = true
      this.utilService.hideSpinner()
      this.utilService.showErrorCall(err);
    });
  }

  loadSeasons(){
      this.isLoading = true;
      this.seriesService.getSeriesDetail(this.id).subscribe((res: any) => {
      if(res){

        this.isLoading = false;
        this.loadSeries = false;
        this.seriesinfo = res;
        this.seriesinfo.selectedEpisodes = this.seriesinfo.episodes[this.seasonId];
        this.seriesData = JSON.stringify(this.seriesinfo.selectedEpisodes)
        localStorage.setItem('seriesData',this.seriesData)
        this.episodeLen = 0;
        this.episodes = res.episodes;
        console.log(this.episodes,'epigosfjlasdkfjlasdkfj');
      }
      
      if (this.episodes) {
        Object.keys(res.episodes).forEach(key => {
          this.episodeLen = this.episodeLen + res.episodes[key].length;
        });
      }
      this.seasonLen = res.seasons.length;
    }, err => {
      this.isLoading = false;
      this.loadSeries = true
      this.utilService.showErrorCall(err);
    });
  }


  onSelectSeason(seasonId: any) {
    console.log(seasonId,'season Id');

    // this.isLoading = true;
    this.seasonId = seasonId;
    this.seriesinfo.selectedEpisodes = [];
    setTimeout(() => {

    this.seriesinfo.selectedEpisodes = this.seriesinfo.episodes[this.seasonId];
    console.log(this.seriesinfo.selectedEpisodes,'new selected........');
    this.seriesData = JSON.stringify(this.seriesinfo.selectedEpisodes);
    localStorage.setItem('seriesData',this.seriesData);
    this.isLoading=false;
  }, 0);

    // setTimeout(() => {
    //   this.isLoading = false;
    // }, 0);
  }

  // playSeries(id:any,ext:any,title:any){
  //    this.router.navigate([`series/watch/+${id}/+${ext}`])
  // }


  onSave(item: any) {
    if(this.isLocal == true){
      let savedArray = [];
      let isExist: any;
    const msg =this.translate.instant('COMMON.ADDED_SUCCESS_MSG')
    savedArray = JSON.parse(localStorage.getItem(Constant.SERIES_FAV)) || [];
    const seriesId = typeof this.id === 'number' ? this.id : String(this.id);
    console.log(item,seriesId,'ok');
    
    if (savedArray.length > 0) {
      // isExist = _.findIndex(savedArray, { id: (this.id) });
      isExist = _.findIndex(savedArray, { id: seriesId });
      
      if (isExist == -1) {
        item.isList = false;
        savedArray.push({ id: seriesId, img: item.info.cover, name: item.info.name, fullUrl: localStorage.getItem(Constant.FULLURL_KEY) });
        localStorage.setItem(Constant.SERIES_FAV, JSON.stringify(savedArray));
        this.isFavourit = true;
        this.utilService.showErrorSuccess(`${msg}`);
      }
      if (isExist >= 0) {
        this.utilService.showErrorInfo('Item alreadey added to favourite')
      }
      
    }
    else { //first
      item.isList = false;
      this.isFavourit = true;
      savedArray.push({ id: seriesId, img: item.info.cover, name: item.info.name, fullUrl: localStorage.getItem(Constant.FULLURL_KEY) });
      localStorage.setItem(Constant.SERIES_FAV, JSON.stringify(savedArray));
      this.utilService.showErrorSuccess(`${msg}`);
      
    }
    }else{
    // console.log(item.episodes[0].container_extension);
    // const extension = item.movie_data.container_extension;
    // const streamId = this.seriesService.getStreamSeriesUrl(item.id, item.episodes[1][0].container_extension);
    // const urls = [streamId , item.info.movie_image]

    const body = {
      profile_id:this.profile_id,
      content_type: "series",
      content_id: this.id,
      content_url: item.info.cover
    }
    console.log(item,body);
    
    this.playlistService.addFavorites(body).subscribe((res:any) =>{
      this.isFavourit = true;
      console.log(res);
    })
    }

    
  }
  deleteFavourite(item: any) {
    item.id = (this.id);
    const msg = this.translate.instant('COMMON.REMOVE_SUCCESS_MSG')

    this.utilService.deleteFavourit(Constant.SERIES_FAV, item, (result: any) => {
      if (result) {
        this.utilService.showErrorSuccess(`${msg}`);
        this.isFavourit = false;
      }
    });
  }

  playSeries(series) {
   if(this.OToken){
    const link = series.links.mp4 ? series.links.mp4 : series.links.mkv; // Choose mp4 if available, otherwise mkv
    this.router.navigate([`/series/watch/${series.id}`],{state:{link:link}});
   }else{
    this.router.navigate([`/series/watch/${series.id}`],{state:{container_extension:series.container_extension}});
   }
  }

  openVlcs(event: Event, series: any): void {
    event.stopPropagation(); 
    if(this.OToken){
      const link = series.links.mp4 ? series.links.mp4 : series.links.mkv;
      this.utilService.send('start', link);
    }else{
      const streamId = this.seriesService.getStreamSeriesUrl(series.id, series.container_extension);
      this.utilService.send('start', streamId);
    }
  }
  scrollRight() {
  const container = this.scrollContainer.nativeElement;
  const firstItem = this.seriesItems.first?.nativeElement;
  if (!firstItem) return;

  const itemWidth = firstItem.offsetWidth;
  const containerWidth = container.clientWidth;

  // Calculate how many items fit fully in view
  const itemsPerView = Math.floor(containerWidth / itemWidth) || 1;
  const scrollAmount = itemWidth * itemsPerView;

  container.scrollBy({ left: scrollAmount, behavior: 'smooth' });

  setTimeout(() => this.checkScrollPosition(), 250);
}

scrollLeft() {
  const container = this.scrollContainer.nativeElement;
  const firstItem = this.seriesItems.first?.nativeElement;
  if (!firstItem) return;

  const itemWidth = firstItem.offsetWidth;
  const containerWidth = container.clientWidth;

  const itemsPerView = Math.floor(containerWidth / itemWidth) || 1;
  const scrollAmount = itemWidth * itemsPerView;

  container.scrollBy({ left: -scrollAmount, behavior: 'smooth' });

  setTimeout(() => this.checkScrollPosition(), 250);
}


  checkScrollPosition() {
    const container = this.scrollContainer.nativeElement;
    this.isAtStart = container.scrollLeft === 0;
    this.isAtEnd = Math.ceil(container.scrollLeft + container.clientWidth) >= container.scrollWidth;
  }
  checkScrollability() {
  const container = this.scrollContainer?.nativeElement;
  if (!container) return;

  // If scroll width is greater than visible width, it's scrollable
  this.isScrollable = container.scrollWidth > container.clientWidth;
}


  onResize = () => {
  this.checkScrollability();
  this.checkScrollPosition();
}

  back(catId: any) {
    // this.router.navigate(['/series'], { queryParams: { category: catId } });
    if (this.seriesFrom == 'search') {
      this.router.navigate(['search']);
    } else if (this.seriesFrom == 'series') {
      this.router.navigate(['/series'], { queryParams: { category: catId } });
    } else if (this.seriesFrom == 'favourites') {
      this.router.navigate(['/favourites']);
    } else {
      this.router.navigate(['/series'], { queryParams: { category: catId } });
    }
  }

  ngOnDestroy(): void {
  window.removeEventListener('resize', this.onResize);
}
}